<template>
  <v-expansion-panel
      :key="orderConfig.id"
      :class="{ 'is-mobile': isMobile}"
  >
    <v-expansion-panel-header
        v-if="!searchIsActive"
        class="sl-expansion-panel pl-2 v-expansion-panel-header--reversed"
    >
      <div class="sl-expansion-panel-header warehouse-order-panel-header">
        <div class="panel-title">
          <div>
            {{ date.format('DD.MM.YYYY')  }}
          </div>
          <div>
            {{ orderConfig.living_unit_name }}
          </div>
          <div
              v-if="orderConfig.direct_order"
              class="direct-order "
              :class="{'text--primary':orderConfig.status !== 'done', 'opacity-50':orderConfig.status === 'done', }"
          >
            <span class="icon-ausrufezeichen-ausgefuellt"></span>
            <span class="mt-1 text-caption">Sofortbestellung</span>
          </div>
        </div>

        <div class="panel-info">
          <div class="d-none d-lg-block">
            <div>
              <b>{{ $t('sl.warehouse.panel.article') }}</b>
            </div>
            <div>
              {{ orderConfig.items_count }}
            </div>
          </div>
          <div class="d-none d-lg-block">
            <div>
              <b>{{ $t('sl.warehouse.panel.status') }}</b>
            </div>
            <div>
              {{ $t('sl.warehouse.order-status.' + orderConfig.status) }}
            </div>
          </div>

          <div class="status" :class="{'primary--text': orderConfig.status !== 'done', 'opacity-50': orderConfig.status === 'done'}">
            <div class="icon-sanduhr" v-if="orderConfig.status === 'partially_delivered'"></div>
            <div class="icon-haekchen" v-else-if="orderConfig.status === 'done'"></div>
            <div class="icon-neu" v-else></div>
          </div>
        </div>

      </div>
    </v-expansion-panel-header>

    <v-expansion-panel-content class="px-0">
      <v-progress-circular
          v-if="isLoading || !isReady"
          indeterminate c
          color="primary"
          class="ma-4"
      />

      <div v-else-if="order" class="warehouse-order-panel-content">
        <div class="title-section">
          <h2 class="primary--text mt-6 mb-2">{{$t('sl.sections.commissioning')}}</h2>

          <div class="show-residents">
            <v-checkbox
                v-model="showResidents"
                label="Bewohner einblenden"
            />
          </div>

          <div class="print">
            <PrintPdf
                v-if="!isOrderCompleted"
                :filename="'ruestliste_'+$moment(order.date).format('DD-MM-YYYY')+'_'+order.id+'.pdf'"
                :uri="`warehouse/picking-list/${order.id}`"
                @loading="updateLoading"
            >
              <template v-slot:default="{ eventHandlers, loading }">
                <div v-on="eventHandlers" class="hover-link text-center" style="width: 80px;">
                  <v-progress-circular
                      v-if="loadingPdf"
                      indeterminate
                      color="primary"
                      size="35"
                      class="mb-2 text-center"
                  />
                  <div class="icon-drucken text-center mb-2" style="font-size: 35px;" v-if="!loadingPdf"></div>
                  <div style="font-size: 14px">Rüstliste</div>
                </div>
              </template>
            </PrintPdf>

            <PrintClearingListButton :partialDeliveries="completedPartialDeliveries"></PrintClearingListButton>
          </div>
        </div>

        <component
            :is="activeView"
        />
      </div>

    </v-expansion-panel-content>
  </v-expansion-panel>

</template>

<script>
import {mapGetters} from "vuex";
import httpClient from "@/utils/httpClient";
import OrderArticle from "@/components/SmartLogistics/Warehouse/Partials/OrderArticle.vue";
import OrderArticleHeader from "@/components/SmartLogistics/Warehouse/Partials/OrderArticleHeader.vue";
import PrintPdf from "@/components/SmartLogistics/Print/PrintPdf.vue";
import BasicOrderView from "@/components/SmartLogistics/Warehouse/Views/Commissioning/BasicOrderView.vue";
import ArticleResidentView from "@/components/SmartLogistics/Warehouse/Views/Commissioning/ArticleResidentView.vue";
import {internalOrderMixin} from "@/mixins/SmartLogistics/ModelC/internalOrder";
import PrintClearingListButton from "@/components/SmartLogistics/ModelC/ClearingList/PrintClearingListButton.vue";

export default {
  name: 'OrderExpansionPanel',
  components: {PrintClearingListButton, BasicOrderView, PrintPdf, OrderArticleHeader, OrderArticle},
  mixins: [internalOrderMixin],

  props: {
    orderConfig: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      loadingPdf: false,
      showResidents: true,
    }
  },

  computed: {
    ...mapGetters({
      isMobile: 'system/isMobile',
      searchIsActive: 'smartLogisticSettings/searchIsActive',
      activePanels: 'smartLogisticWarehouse/activePanels',
    }),

    isPanelActive() {
      if (Array.isArray(this.activePanels)) {
        return this.activePanels.includes(this.index)
      } else {
        return this.activePanels === this.index
      }
    },

    activeView() {
      if (this.showResidents) {
        return ArticleResidentView
      }

      return BasicOrderView;
    },

    date() {
      return this.$moment.unix(this.orderConfig.date)
    }
  },

  methods: {
    fetchOrder() {
      this.$store.dispatch('smartLogisticWarehouse/fetchOrderData', this.orderId)
    },

    updateLoading(value) {
      this.loadingPdf = value
    },
  },

  watch: {
    isPanelActive(val) {
      if (val) {
        this.$store.commit('smartLogisticWarehouse/setCurrentOrderId', this.orderConfig.id)
        this.fetchOrder()
      }
    }
  }
}

</script>
